/**
 * Shared formatting functions - Single source of truth
 * Used across pages and components for consistent display
 */

export const formatPrice = (price) => {
  if (!price) return '';
  return new Intl.NumberFormat('fr-BE', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 0,
  }).format(price);
};

export const formatMileage = (mileage) => {
  if (!mileage) return '';
  return new Intl.NumberFormat('fr-BE').format(mileage) + ' km';
};

export const formatPowerFull = (powerKw) => {
  if (!powerKw) return '';
  return `${powerKw} kW (${Math.round(powerKw * 1.36)} ch)`;
};

export const formatPowerShort = (powerKw, powerHp) => {
  if (powerHp) return `${powerHp} CV`;
  if (powerKw) return `${powerKw} kW`;
  return '';
};

export const formatAppointmentDate = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr + 'T00:00:00');
  return date.toLocaleDateString('fr-BE', { weekday: 'short', day: 'numeric', month: 'short' });
};

export const formatAppointmentDateLong = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(dateStr + 'T00:00:00');
  return d.toLocaleDateString('fr-BE', { weekday: 'long', day: 'numeric', month: 'long' });
};

export const isPastAppointment = (dateStr) => {
  const appointmentDate = new Date(dateStr + 'T23:59:59');
  return appointmentDate < new Date();
};
